import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import {
  clearPulseNotifications,
  clearTeamNotifications,
} from "@microdoing/shared/services/notification/actions";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import {
  getPulseNotifications,
  getTeamNotifications,
} from "@microdoing/shared/services/notification/selectors";
import i18n from "@microdoing/shared/i18n";
import { sendPulseNotification } from "@microdoing/shared/services/user/actions";
import TeamRow from "./TeamRow";
import { MainText, Box } from "app/components/common";
import {
  getCampaignId,
  getTeam,
} from "@microdoing/shared/services/userCampaign/selectors";
import { useNavigation } from "@react-navigation/native";

const MyTeam = () => {
  const userId = useSelector(getUserId);
  const campaignId = useSelector(getCampaignId);
  const team = useSelector(getTeam);
  const teamNotifications = useSelector(getTeamNotifications);
  const pulseNotifications = useSelector(getPulseNotifications);
  const navigation = useNavigation();

  const sortedUsers = useMemo(() => {
    const { users } = team;

    const usersSorted = users
      .filter(el => el.user !== userId)
      .sort((a, b) => b.weekActions - a.weekActions);
    const user = users.filter(el => el.user === userId);
    usersSorted.push(...user);
    return usersSorted;
  }, [team.users, userId]);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(clearPulseNotifications({ userId }));
      dispatch(clearTeamNotifications({ campaignId }));
    }, 7750);
  }, [userId]);

  const navigateExternalProfile = id => () => {
    if (id === userId) {
      return navigation.navigate("UserProfile");
    }
    dispatch(requestExternalUser({ userId: id }));
  };

  const onPressPulse = friendId => () => {
    dispatch(
      sendPulseNotification({
        userId,
        friendId,
      }),
    );
  };

  const getNumberOfActivePlayers = useMemo(() => {
    const { users } = team;

    const total = users.reduce((prev, curr) => {
      if (curr.weekActions > 0) {
        prev += 1;
      }
      return prev;
    }, 0);
    return total;
  }, [team.users]);

  const hasPulse = teammateId => {
    const hasPulseNotification = pulseNotifications.find(
      el => el.user === teammateId,
    );

    if (hasPulseNotification) {
      return true;
    }

    const hasTeamNotification = teamNotifications.find(
      el => el.user === teammateId,
    );

    if (hasTeamNotification) {
      return true;
    }

    return false;
  };

  return sortedUsers.map(teammate => {
    const teammateId = teammate.user;
    return (
      <TeamRow
        key={teammateId}
        user={teammate}
        isUser={teammateId === userId}
        hasPulse={hasPulse(teammateId)}
        onPress={navigateExternalProfile(teammateId)}
        onPressPulse={onPressPulse(teammateId)}
      />
    );
  });
};

export default MyTeam;
